module.exports = __webpack_public_path__ + "img/pic_location_Nantou.0ca7e330.png";